import React from 'react';
import { useMsal } from '@azure/msal-react';
import config from '../../config';

// Renders a button which, when selected, will redirect the page to the logout prompt
const SignOutButton = () => {
  async function handleLogout(instance) {
    config.clearTokenLocalStorage();
    await instance.logoutRedirect().catch((e) => {
      console.error(e);
    });
  }

  const { instance } = useMsal();

  return (
    <button
      className='navigation-button'
      onClick={() => handleLogout(instance)}
    >
      Sign Out
    </button>
  );
};

export default SignOutButton;
